import React, { lazy } from 'react';
import { loadPostPage } from './utils/pagePreloads.js';

const Home = lazy(() => import('./pages/Home'));
const Break = lazy(() => import('./pages/Break'));
const Math = lazy(() => import('./pages/Math'));
const Projects = lazy(() => import('./pages/Projects'));
const Achieved = lazy(() => import('./pages/Achieved'));
const Admin = lazy(() => import('./pages/Admin'));
const Post = lazy(loadPostPage);

const routes = [
  { path: '/', component: <Home />, exact: true },
  { path: '/break', component: <Break /> },
  { path: '/math', component: <Math /> },
  { path: '/projects', component: <Projects /> },
  { path: '/achieved', component: <Achieved /> },
  { path: '/admin', component: <Admin /> },
  { path: '/post', component: <Post /> },
  { path: '/post/:slug', component: <Post /> },
];

export default routes;
